import React from "react";
import "./ProductDetailsResult.css";
import {
  convertTime,
  convertTimestampToDateTime,
} from "../../utils/ProductStatus";
import { Badge, Card, CardHeader, CardTitle } from "react-bootstrap";
import { SignalHigh, Smartphone } from "lucide-react";
import { CardContent } from "@mui/material";
import WarrantyDetails from "../../pages/ProductDetails/WarrantyDetails";
import TransactionCard from '../TransactionCard';
import { useState, useEffect } from "react";


const ProductDetailsResult = ({
  condition,
  brand,
  model,
  imei1,
  imei2,
  serial,
  varient,
  status,
  customer,
  retailer,
  history,
  qcBy,
  qcPrice,
  qcDescription,
  PhoneImg,
  warrnty,
  transaction
}) => {


  const [transactionFlow, setTransactionFlow] = useState([]);

  useEffect(() => {
    if (transaction.length > 0) {
      const sortedTransactions = transaction.sort((a, b) => (a.date?.seconds || 0) - (b.date?.seconds || 0));
      
      // Create the proper flow from Admin → Distributor → Retailer
      const structuredFlow = [];
      
      transaction.forEach(txn => {
        if (txn.from === "admin") {
          structuredFlow.push(txn);
  
          // If the transaction is from Admin to Distributor, check if a second transaction exists from Distributor to Retailer
          const nextTxn = transaction.find(t => t.from === "distributor" && t.fromDistributorId?.id === txn.toEntityId?.id);
          if (nextTxn) structuredFlow.push(nextTxn);
        }
      });
  
      setTransactionFlow(structuredFlow);
    }
  }, [transaction]);

  return (
    <div className="p-6 text-black">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <DeviceInfoCard
            phoneImg={PhoneImg}
            brand={brand}
            model={model}
            imei1={imei1}
            imei2={imei2}
            serial={serial}
            varient={varient}
            condition={condition}
            status={status}
            history={history}
            qcBy={qcBy}
            qcDescription={qcDescription}
            qcPrice={qcPrice}
          />
        </div>

        {/* Right Section - Customer, Retailer & Warranty */}
        <div className="flex flex-col gap-6">
    
  
          <div className="bg-white p-5 rounded-lg shadow m-2">
  <h3 className="text-lg font-semibold border-b pb-2 mb-3">Transaction Details</h3>

  <div className="p-3 flex items-center flex-col bg-gray-100 rounded-lg">
    <TransactionCard isAdmin={true} />
    {transactionFlow.length > 0 ? (
      transactionFlow.map((txn, index) => (
        <TransactionCard key={index} data={txn} />
      ))
    ) : (
      <p className="text-gray-500 text-center">No transactions found.</p>
    )}
  </div>


          </div>


        {/* Customer Details */}
        <CustomerDetails customer={customer} />

          {/* Warranty Details */}
          <div>
            {!warrnty ? (
              <p className="text-gray-500 italic">
                No Warranty data available.
              </p>
            ) : (
              <WarrantyDetails
                warrantyEnded={warrnty.warrantyEnded}
                warrantyStarted={warrnty.warrantyStarted}
                transactionId={warrnty.transactionId}
                status={warrnty.status}
                claims={warrnty.claims}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsResult;

const DeviceInfoCard = ({ brand, model, imei1, imei2, status, history, phoneImg,serial,varient,condition,qcBy,qcDescription,qcPrice }) => {
  const formatDate = (seconds) => {
    if (!seconds) return "Invalid Date";
    return new Date(seconds * 1000).toLocaleString();
  };

  return (
    <div className="w-full max-w-3xl mx-auto p-6 bg-white shadow-xl rounded-2xl">
      <div className="border-b pb-4 flex items-center gap-3">
        <span className="text-xl">📱</span>
        <h2 className="text-xl font-bold bg-white text-gray-800">Device Information</h2>
        <span
          className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
            condition === "Gold"
              ? "bg-yellow-500 text-white"
              : condition === "Platinum"
              ? "bg-gray-300 text-black"
              : condition === "Silver"
              ? "bg-gray-400 text-white"
              : "bg-yellow-300 text-black"
          }`}
        >
          {condition}
        </span>
      </div>
      <div className="mt-4">
        {/* Left Side - Image */}
        <div className="relative flex justify-center items-center">
          <div className="bg-gray-100 p-4 rounded-lg w-full h-64 flex items-center justify-center relative">
            <img
              src={phoneImg || "/api/placeholder/300/400"}
              alt="Device"
              className="max-h-full object-contain rounded-lg shadow-md"
            />
          </div>
        </div>

        {/* Right Side - Info */}
        <div className="flex flex-col space-y-4">
          <div className="grid grid-cols-2 gap-4 bg-gray-50 p-4 rounded-lg">
            <InfoItem label="Brand" value={brand} />
            <InfoItem label="Model" value={model} />
            <InfoItem label="IMEI 1" value={imei1} mono />
            <InfoItem label="IMEI 2" value={imei2} mono />
            <InfoItem label="Serial Number" value={serial} mono />
            <InfoItem label="Variant" value={varient} mono />
            <InfoItem label="Engineer Name" value={qcBy} mono />
            <InfoItem label="QC Cost" value={qcPrice} mono />
            <InfoItem label="QC Description" value={qcDescription} mono />
          </div>

          {/* Current Status */}
          <div className="border-t pt-4 flex">
            <h3 className="text-sm font-medium text-gray-500 mr-16">Current Status : </h3>
            <span className="text-lg font-bold bg-blue-100 text-blue-600 px-4 py-2 rounded-md mt-2 inline-block">
              {status.toUpperCase()}
            </span>
          </div>

          {/* Status History */}
          <div className="border-t pt-4">
            <h3 className="text-sm font-medium text-gray-500 mb-2">Status History</h3>
            <div className="space-y-3">
              {history?.map((his, index) => (
                <div key={index} className="flex justify-between p-3 bg-gray-100 rounded-lg">
                  <span className="text-blue-600 font-bold px-3 py-1 rounded-md">{his.status}</span>
                  <span className="text-sm text-gray-600">{formatDate(his.timestamp)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const InfoItem = ({ label, value, mono }) => (
  <div className="flex flex-col">
    <h3 className="text-sm font-medium text-gray-500">{label} : </h3>
    <p className={`text-lg font-semibold ${mono ? "font-mono text-gray-700" : "text-gray-800"}`}>{value}</p>
  </div>
);



const CustomerDetails = ({ customer }) => {
  if (!customer) {
    return <p className="text-gray-500">No customer data available.</p>;
  }
  return (
    <div className="p-4 bg-white shadow rounded-md">
      <h3 className="text-md font-semibold mb-2">Customer Details</h3>
    <div className=" text-sm flex justify-evenly" style={{borderTop:"1px solid #dbd9d9"}}>
      <div className="flex  items-center">
        <img
          src={customer.imageUrl}
          alt="Customer"
          className="w-28 h-28 rounded mb-2 "
        />
        <img
          src={customer.signatureUrl}
          alt="Signature"
          className="w-28"
        />
      </div>
      <div className="flex flex-col justify-center">
        
        <p><strong>Name:</strong> {customer.name}</p>
        <p><strong>Email:</strong> {customer.email}</p>
        <p><strong>Mobile:</strong> {customer.phone}</p>
        <p><strong>Address:</strong> {customer.address || "N/A"}</p>
        <p><strong>Price:</strong> {customer.retailerPrice || "N/A"}</p>
      </div>
    </div>
    </div>
  );
};
